import React from 'react'
import styled from 'styled-components'

import { Link } from 'react-router'

export default ({ status }) => (
  <Wrapper>
    <Status>{status || `500`}</Status>
    <Title>OOPS, PARECE QUE A MANGUEIRA TORCEU</Title>
    <Text>Ocorreu um erro interno no servidor</Text>
    <Goback to={`/`}>Voltar ao inicio</Goback>
  </Wrapper>
)

const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Text = styled.span`
  color: #676767;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  display: block;
`

const Title = styled.h2`
  color: #676767;
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
`

const Goback = styled(Link)`
  margin: 10px;
  background: none;
  border: 1px solid #dedede;
  outline: none;
  padding: 10px;
  text-decoration: none;
  font-weight: bold;
  color: #222;
`

const Status = styled.span`
  display: block;
  color: #93c13e;
  font-family: Nunito;
  font-size: 72px;
  font-weight: bold;
  line-height: 72px;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/Error/index.js